export default "__VITE_ASSET__CaDMd$rZ__"